import { render } from "./ErrorIcon.vue?vue&type=template&id=7861c5c7"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__